export const FULL_GRID_VIEW_SIZE = 6;
